document.addEventListener("DOMContentLoaded", function () {
  // Sticky Menu Logic
  const stickyMenu = document.querySelector(".sticky-menu");
  if (stickyMenu) {
    const scrollThreshold = 10;
    const bufferZone = 5;
    let isCompact = false;
    const hasAdminBar =
      document.documentElement.classList.contains("admin-bar");
    const adminBarHeight = 32;
    const initialTop = hasAdminBar ? adminBarHeight : 0;

    function handleScroll() {
      const currentScrollY = window.scrollY;
      if (isCompact) {
        if (currentScrollY < scrollThreshold - bufferZone) {
          stickyMenu.classList.remove("is-compact");
          isCompact = false;
        }
      } else {
        if (currentScrollY > scrollThreshold + bufferZone) {
          stickyMenu.classList.add("is-compact");
          isCompact = true;
        }
      }
    }
    if (window.scrollY > scrollThreshold) {
      stickyMenu.classList.add("is-compact");
      isCompact = true;
    }
    window.addEventListener("scroll", handleScroll);
  }

  // Removed custom mobile menu toggle logic - Relying on WP Core
});
